import { render, staticRenderFns } from "./StInputText.vue?vue&type=template&id=5afd9117&"
import script from "./StInputText.vue?vue&type=script&lang=js&"
export * from "./StInputText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports